export enum dashboardPWTypes {
  GET_FILTER_LISTPW = '@@dashboard/GET_FILTER_LISTPW',
  GET_FILTER_LIST_SUCCESSPW = '@@dashboard/GET_FILTER_LIST_SUCCESSPW',
  GET_FILTER_LIST_FAILPW = '@@dashboard/GET_FILTER_LIST_FAILPW',

  GET_FILTER_DATAPW = '@@dashboard/GET_FILTER_DATAPW',
  GET_FILTER_DATA_SUCCESSPW = '@@dashboard/GET_FILTER_DATA_SUCCESSPW',
  GET_FILTER_DATA_FAILPW = '@@dashboard/GET_FILTER_DATA_FAILPW',
}
